import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { AssetUnavailabilityComponent } from './asset-unavailability.component';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { ItemArrowComponent } from '../../core/components/item-arrow/item-arrow.component';
import { FiltersModule } from 'src/app/filters/filters.module';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'asset-unavailability/:categoryId/:productTypeId',
        component: AssetUnavailabilityComponent,
        canActivate: [AuthGuard],
      },
    ]),
    CommonModule,
    CoreModule,
    MatTooltipModule,
    NgChartsModule,
    ItemArrowComponent,
    FiltersModule,
  ],
  providers: [],
  declarations: [AssetUnavailabilityComponent],
})
export class AssetUnavailabilityModule {}
